
import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, FileText, Lock, Cookie, CheckCircle, Wand2, User, BarChart3 } from 'lucide-react';

export const FooterLegalLinks = () => {
  const legalLinks = [{
    name: 'My Profile',
    href: '/profile',
    icon: User,
    prominent: true
  }, {
    name: 'Privacy Policy',
    href: '/privacy',
    icon: Lock
  }, {
    name: 'Terms of Service',
    href: '/legal#terms',
    icon: FileText
  }, {
    name: 'Cookie Policy',
    href: '/cookie-policy',
    icon: Cookie
  }, {
    name: 'GDPR',
    href: '/gdpr-compliance',
    icon: CheckCircle
  }, {
    name: 'Price Beat Guarantee',
    href: '/price-beat-guarantee',
    icon: Shield
  }, {
    name: 'Analytics',
    href: '/analytics',
    icon: BarChart3
  }, {
    name: 'Project Wizard',
    href: '/website-wizard',
    icon: Wand2
  }];
  
  return (
    <div>
      <h3 className="mb-4 text-base font-semibold text-white">Legal & Support</h3>
      <ul className="space-y-2">
        {legalLinks.map(link => (
          <li key={link.name}>
            <Link to={link.href} className={`group flex min-h-0 items-center py-0.5 text-sm leading-5 transition-colors ${
              link.prominent 
                ? "text-blue-300 hover:text-blue-200 font-medium" 
                : "text-gray-300 hover:text-blue-400"
            }`}>
              <link.icon className={`h-4 w-4 mr-3 flex-shrink-0 ${
                link.prominent 
                  ? "text-blue-300 group-hover:text-blue-200" 
                  : "group-hover:text-blue-400"
              }`} />
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
      
      <div className="mt-5">
        <div className="mb-2 flex items-center">
          <Shield className="h-4 w-4 mr-2 text-green-400" />
          <span className="text-sm font-semibold text-white">Cost Guarantee</span>
        </div>
        <p className="text-xs text-gray-300 leading-relaxed">25% cost reduction on your best quote or we will give you £1,000 (Subject to T&Cs). All plans include 3-year maintenance, security and support.</p>
      </div>
    </div>
  );
};
